
<div class="race-container">
  <h2>Prijavnica</h2>
  <p>Prosimo izpolnite podatke.</p>
  
  <form [formGroup]="raceForm" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-column">
        <label for="name">Ime in priimek:</label>
        <input id="name" type="text" formControlName="name" required />
        
        <label for="email">Email:</label>
        <input id="email" type="email" formControlName="email" required />
        
        <label for="yearOfBirth">Leto rojstva:</label>
        <input id="yearOfBirth" type="number" formControlName="yearOfBirth" required />
        
        <label for="sex">Spol:</label>
        <select id="sex" formControlName="sex">
          <option value="Male">Moški</option>
          <option value="Female">Ženska</option>
          <option value="Other">Ostalo</option>
        </select>
        
        <label for="address">Naslov:</label>
        <input id="address" type="text" formControlName="address" required />
      </div>
      
      <div class="form-column">
        <label for="club">Klub:</label>
        <input id="club" type="text" formControlName="club" />
        
        <label for="phone">Telefon:</label>
        <input id="phone" type="text" formControlName="phone" required />
        
        <label for="citizenship">Državljanstvo:</label>
        <input id="citizenship" type="text" formControlName="citizenship" required />

        <label for="numOfLaps">Željeno število krogov:</label>
        <select id="numOfLaps" formControlName="numOfLaps" required>
          <option *ngFor="let num of [1,2,3,4,5,6,7,8,9]" [value]="num">{{ num }}</option>
        </select>

        <label for="timeOfArrival">Čas začetka:</label>
        <select id="timeOfArrival" formControlName="timeOfArrival" required>
          <option *ngFor="let hour of [12,13,14,15,16,17,18,19,20]" [value]="hour + ':00'">{{ hour }}:00</option>
        </select>
      </div>
    </div>
    <button type="submit" [disabled]="!raceForm.valid">Pošlji prijavo</button>
  </form>
</div>
  
<!-- Table of Racers -->
<div *ngIf="isOrgAdmin" class="container table mt-5">
  <h3>Seznam tekačev</h3>
  <p>Število prijavljenih: {{ racers.length }}</p>

  <!-- Scrollable container -->
  <div style="overflow-x: auto; width: 100%;">
    <table *ngIf="racers.length > 0" border="1" cellpadding="10" cellspacing="0" style="width: 100%; margin-top: 20px; white-space: nowrap;">
      <thead>
        <tr>
          <th>Ime</th>
          <th>Email</th>
          <th>Leto rojstva</th>
          <th>Spol</th>
          <th>Klub</th>
          <th>Telefon</th>
          <th>Državljanstvo</th>
          <th>Število krogov</th>
          <th>Čas prihoda</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let racer of racers">
          <td>{{ racer.name }}</td>
          <td>{{ racer.email }}</td>
          <td>{{ racer.yearOfBirth }}</td>
          <td>{{ racer.sex }}</td>
          <td>{{ racer.club }}</td>
          <td>{{ racer.phone }}</td>
          <td>{{ racer.citizenship }}</td>
          <td>{{ racer.numOfLaps }}</td>
          <td>{{ racer.timeOfArrival }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <p *ngIf="racers.length === 0">Ni še registriranih tekmovalcev.</p>
  <!-- Add the download button -->
  <button (click)="downloadCSV()">Naloži CSV</button>
</div>

